import React from 'react';
import Footer from '../components/Footer';

const cormorantFont = { fontFamily: "'Cormorant Garamond', serif" };

function ComingSoon() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center bg-gradient-to-b from-green-600 to-green-700 py-16 px-4">
        <div className="max-w-3xl mx-auto text-center">
          {/* Logo */}
          <div className="mb-8">
            <img 
              src={process.env.PUBLIC_URL + '/logo-2.png'} 
              alt="Glenullin GAC Logo" 
              className="h-32 sm:h-40 w-auto mx-auto rounded shadow-lg"
            />
          </div>

          {/* Coming Soon Heading */}
          <h1 
            className="text-5xl sm:text-6xl md:text-7xl font-bold text-white mb-6 drop-shadow-lg"
            style={cormorantFont}
          >
            Coming Soon
          </h1>

          {/* Gold Divider */}
          <div className="w-32 h-1 bg-yellow-400 mx-auto mb-8" />

          {/* Message */}
          <p 
            className="text-xl sm:text-2xl md:text-3xl text-white mb-4 drop-shadow"
            style={cormorantFont}
          >
            We're working on something amazing!
          </p>
          <p className="text-lg sm:text-xl text-green-100 mb-8">
            Our new website is under construction. Check back soon for updates.
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ComingSoon;

